<template>
    <div>
        <small>Personalice la imagen que aparecerá en el comunicado.</small>
        <p class="mt-3">Archivo de importación</p>
        <div class="row" >
            <div class="col-md-12">
                <b-col class="px-0 pb-1 pb-md-0 col" v-if="form.imageNotification" v-cloak>
                <div class="w-100 p-2 file-drop-area">
                    <b-input-group class="invoice-list-area">
                    <b-form-input
                        placeholder="File name..."
                        v-model="form.imageNotification.name"
                        class="bg-gray-input border-0"
                    />
                    <b-input-group-append class="bg-gray-input">
                        <b-button variant="outline" class="border-0" size="sm" @click="removeimageNotification()">
                        <feather-icon icon="XIcon" size="20"/>
                        </b-button>
                    </b-input-group-append>
                    </b-input-group>
                </div>
                </b-col>
                <b-col class="px-0 pb-1 pb-md-0 col" v-if="!form.imageNotification">
                <div class="file-drop-area" >
                    <input type="file" name="imageNotification" id="imageNotification" class="file-input invisible" @change="changeimageNotification" accept="image/*"/>
                    <label for="imageNotification" class="w-100 text-center cursor-pointer m-0 custom-label">
                      <feather-icon icon="UploadCloudIcon" size="22"/>
                      <span>Seleccionar archivo</span>
                    </label>
                </div>
                </b-col>
            </div>
            <div class="col-md-12 d-flex align-items-center justify-content-end mt-3">
                <b-button variant="success" :disabled="!form.imageNotification || loading" @click="uploadNotificationImage()">
                <span>Confirmar</span>
                </b-button>
            </div> 
        </div>
    </div>
</template>
<script>
export default {
  name: 'UploadImage',
  props: ['closeModal'],  
  data () {
    return {
      loading: false,
      form: {
        imageNotification: null
      }
    }
  },
  methods: {
    uploadNotificationImage () {
      this.loading = true
      const fileName = this.form.imageNotification.name
      const filePath = `/notificationImages/${fileName}`
      const storageRef = this.$root.$data.fb.storage().ref(filePath)

      storageRef.getDownloadURL()
        .then((url) => {
          this.selectedImage = {
            name: fileName,
            logo: url
          }
          this.loading = false
          this.$emit('saveImage', this.selectedImage)
        })
        .catch((error) => {
          if (error.code === 'storage/object-not-found') {
            const uploadTask = storageRef.put(this.form.imageNotification)

            uploadTask.on(
              'state_changed',
              (snapshot) => {
                this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
              },
              (uploadError) => {
                this.loading = false
                this.selectedImage = null
                this.$emit('saveImage', this.selectedImage, 'personalize')
                console.error(uploadError)
              },
              () => {
                this.uploadValue = 100
                uploadTask.snapshot.ref.getDownloadURL().then((url) => {
                  this.selectedImage = {
                    name: fileName,
                    logo: url
                  }
                  this.loading = false
                  this.$emit('saveImage', this.selectedImage)
                })
              }
            )
          } else {
            this.loading = false
          }
        })
    },
    changeimageNotification(e) {
      this.form.imageNotification = e.target.files[0]
    },
    removeimageNotification() {
      this.form.imageNotification = null
      this.keyFormRender++
    },
    close() {
      this.removeimageNotification()
      this.$emit('closeModal')
    }
  }
}
</script>
<style lang="scss" scoped>
  div.file-drop-area {
    padding: 0.4rem 0;
    border: 1.7px solid #B9B9C7;
    border-radius: 0.357rem;
    max-height: 300px;
    overflow-y: auto;
    input.file-input {
      position: absolute;
      height: 0;
    }
  }
  .invoice-list-area{
    padding-bottom: 8px;
  }
  .bg-gray-input {
    background-color: #f7f7f9 !important;
  }
  .custom-label {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #AEAEAE;
    font-size: 15px;
  }
  .custom-label svg {
    stroke-width: 1;
    margin-right: 0.5rem;
  }
  .custom-link {
    text-decoration: underline;
    color: #1B4284 !important;
    font-weight: bold;
  }
</style>